import styled from 'styled-components'

/*
 * The pills a connect field shows while it is empty — "Create G/L account" and
 * whatever comes next. Each one asks a server-side field resolver for the value
 * (POST api/resolve/:name); Connect puts the answer into the form through the
 * field's own valueMap, exactly as if the user had picked it.
 *
 * Laid over the right end of the input, so the field keeps its height and the
 * row its alignment. The pills only render while the field has no value, so
 * they never sit on top of text.
 */
const Actions = styled.span`
    position: absolute;
    top: 50%;
    right: 0.4rem;
    transform: translateY(-50%);
    display: flex;
    gap: 0.25rem;
`

const Pill = styled.button`
    appearance: none;
    padding: 0.1rem 0.6rem;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1.4;
    white-space: nowrap;
    cursor: pointer;
    background-color: ${({ theme }) => theme.emotive.info.bg};
    color: ${({ theme }) => theme.emotive.info.color};
    border: 1px solid ${({ theme }) => theme.emotive.info.border};

    &:hover:not(:disabled) {
        background-color: ${({ theme }) => theme.emotive.info.bgHover};
    }
    &:disabled {
        cursor: progress;
        opacity: 0.6;
    }
`

const ConnectEmptyActions = ({ actions, pending, onRun, t, testId }) => (
    <Actions>
        {actions.map(action => (
            <Pill
                key={action.id}
                type='button'
                disabled={pending !== null}
                onClick={(e) => { e.stopPropagation(); onRun(action) }}
                data-testid={`${testId}.${action.id}`}
            >
                {pending === action.id ? '…' : t(action.label)}
            </Pill>
        ))}
    </Actions>
)

export default ConnectEmptyActions
